export const linkToUserSettings = () => "/user/settings";
export const linkToFirstSignIn = () => "/user/first-sign-in";

export const linkToLogin = () => "/login";

export function linkToAuth0Callback() {
  return "/auth0/callback";
}
